import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardDatabaseComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-databases.html');
    protected type = 'databases';
}
